
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.097 2.354A6.216 6.216 0 0017.103.917a6.33 6.33 0 00-4.51 1.882c-.21.215-.408.446-.592.697-1.43-1.93-3.82-2.92-6.182-2.482-1.961.361-3.503 1.454-4.58 3.246C-.278 6.79-.402 9.23.873 11.513c.682 1.221 1.567 2.412 2.706 3.639 2.085 2.247 4.553 4.38 7.768 6.711.205.15.425.225.654.225.354 0 .592-.181.71-.27 2.901-2.1 5.18-4.036 7.171-6.095 1.113-1.15 2.375-2.563 3.298-4.327.396-.754.847-1.768.82-2.927-.06-2.495-1.035-4.552-2.902-6.115zm.571 8.228c-.822 1.57-1.981 2.864-3.008 3.925-1.842 1.905-3.948 3.707-6.663 5.695-2.954-2.167-5.24-4.157-7.173-6.242-1.043-1.124-1.849-2.205-2.463-3.305-.973-1.74-.865-3.486.34-5.493.812-1.352 1.964-2.174 3.424-2.442.28-.053.564-.078.843-.078 1.731 0 3.265.97 4.13 2.653l.148.282c.15.287.462.45.769.458a.854.854 0 00.753-.485c.304-.63.636-1.117 1.04-1.533a4.623 4.623 0 013.295-1.366c1.073 0 2.104.369 2.904 1.04 1.488 1.245 2.234 2.822 2.282 4.817.016.753-.304 1.47-.62 2.075z","fill":"#828282"}})])
          )
        }
      }
    